<template><div><h1>VUX 2.7.6 released</h1>
<h2><a href="/en/components/button-tab.html">ButtonTab</a></h2>
<ul><li>[fix] fix border disappear bug #2322</li>
</ul>
<h2><a href="/en/components/calendar.html">Calendar</a></h2>
<ul><li>[fix] fix no hiding after selecting the same value #2306</li>
</ul>
<h2><a href="/en/components/load-more.html">LoadMore</a></h2>
<ul><li>[feature] don't need to set the `background-color`</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[fix] fix not emit on-change and input events when cancel or clear</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX 2.7.6 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// 2.7.6-75.vue?4f26717d